import { environment } from '../../environments/environment';

const API_BASE_URL = environment.apiBaseUrls.base;
const LEAD_API_BASE_URL = environment.apiBaseUrls.lead;

export const API = {
  rvsf: {
    search: `${API_BASE_URL}rvsf/detail/search`,
    get: `${API_BASE_URL}rvsf/detail/get`,
    save: `${API_BASE_URL}rvsf/detail/save`,
    update: `${API_BASE_URL}rvsf/detail/update`,
    pinCode: `${API_BASE_URL}pincode/getByPrefix`,
    logout: `${API_BASE_URL}auth/admin/logout`,
  },

  branch: {
    search: `${API_BASE_URL}rvsf/branch/admin/search`,
    save: `${API_BASE_URL}rvsf/branch/admin/save`,
    get: `${API_BASE_URL}rvsf/branch/admin/get`,
    update: `${API_BASE_URL}rvsf/branch/admin/update`,
  },

  rvsfuser: {
    search: `${API_BASE_URL}user/admin/search`,
    searchRole: `${API_BASE_URL}role/admin/search`,
    save: `${API_BASE_URL}user/admin/save`,
    get: `${API_BASE_URL}user/admin/get`,
    update: `${API_BASE_URL}user/admin/update`,
  },

  auth: {
    login: `${API_BASE_URL}auth/admin/login`,
    verifyLoginOtp: `${API_BASE_URL}auth/2fa/admin/login/verify-otp`,
    profile: `${API_BASE_URL}user/admin/profile`,
    setup2fa: `${API_BASE_URL}2fa/admin/setup`,
    verify2fa: `${API_BASE_URL}2fa/admin/verify`,
    deactivate2fa: `${API_BASE_URL}2fa/admin/deactivate`,
  },

  auditlog: {
    search: `${API_BASE_URL}audit-log/admin/search`,
  },

  rvsfAuditLog: {
    search: `${LEAD_API_BASE_URL}rvsf/audit-log/admin/search`,
    activitySummary: `${LEAD_API_BASE_URL}rvsf/audit-log/admin/activity-summary`,
    records: `${LEAD_API_BASE_URL}rvsf/audit-log/admin/records`,
  },

  menu: {
    search: `${API_BASE_URL}menu/admin/search`,
    searchParentManu: `${API_BASE_URL}menu/admin/all-parents`,
    save: `${API_BASE_URL}menu/admin/save`,
    get: `${API_BASE_URL}menu/admin/get`,
    update: `${API_BASE_URL}menu/admin/update`,
  },

  vehicles: {
    category: `${LEAD_API_BASE_URL}vehicle-category/getAll`,
    makersByCategory: `${LEAD_API_BASE_URL}vehicle-make/getcategorymake`,
    modelByCategoryAndmakers: `${LEAD_API_BASE_URL}vehicle-model/getbymakeid`,
    searchMake: `${LEAD_API_BASE_URL}vehicle-make/admin/search`,
    saveMake: `${LEAD_API_BASE_URL}vehicle-make/admin/save`,
    updateMake: `${LEAD_API_BASE_URL}vehicle-make/admin/update`,
    getMake: `${LEAD_API_BASE_URL}vehicle-make/admin/get`,
    searchModel: `${LEAD_API_BASE_URL}vehicle-model/admin/search`,
    saveModel: `${LEAD_API_BASE_URL}vehicle-model/admin/save`,
    updateModel: `${LEAD_API_BASE_URL}vehicle-model/admin/update`,
    getModel: `${LEAD_API_BASE_URL}vehicle-model/admin/get`,
  },

  partMaster: {
    uom: `${LEAD_API_BASE_URL}uom/getAll`,
    partType: `${LEAD_API_BASE_URL}part-type/getAll`,
    partCategory: `${LEAD_API_BASE_URL}part-category/getAll`,
    search: `${LEAD_API_BASE_URL}part/admin/search`,
    save: `${LEAD_API_BASE_URL}part/admin/save`,
    get: `${LEAD_API_BASE_URL}part/admin/get`,
    update: `${LEAD_API_BASE_URL}part/admin/update`,
  },

  dashboard: {
    summarySearch: `${LEAD_API_BASE_URL}rvsf-dashboard/admin/all-data`,
  },

  terms: {
    search: `${API_BASE_URL}platform-terms-agreement/admin/search`,
    save: `${API_BASE_URL}platform-terms-agreement/admin/save`,
    get: `${API_BASE_URL}platform-terms-agreement/admin/get`,
    update: `${API_BASE_URL}platform-terms-agreement/admin/update`,
    latest: `${API_BASE_URL}platform-terms-agreement/latest-details`,
    adminSearch: (id: any) =>
      `${API_BASE_URL}platform-terms-agreement/${id}/rvsf-admin-search`,
    resetRvsfStatus: `${API_BASE_URL}platform-terms-agreement/admin/reset-status`,
  },

  releaseNote: {
    recipients: `${API_BASE_URL}release-note/admin/recipients`,
    releaseTypes: `${API_BASE_URL}release-type/getAll`,
    save: `${API_BASE_URL}release-note/admin/save`,
    update: (id: number | string) => `${API_BASE_URL}release-note/admin/update/${id}`,
    search: `${API_BASE_URL}release-note/admin/search`,
    get: (id: number | string) => `${API_BASE_URL}release-note/admin/get/${id}`,
    deactivate: (id: number | string) => `${API_BASE_URL}release-note/admin/deactivate/${id}`,
  },
};
